export default __webpack_public_path__ + "static/media/arrowDown.644845af.svg";